(ns manatee.routing
  (:require [bidi.bidi :as bidi]
            [bidi.verbose :refer [branch param leaf]]))

;; Required to match route when param contains special characters
#?(:clj (extend-protocol bidi/PatternSegment
          clojure.lang.Keyword
          (segment-regex-group [_] "[A-Za-z0-9\\-\\_\\.\\:]+")
          (param-key [this] this)
          (transform-param [_] identity)
          (unmatch-segment [this params]
            (if-let [v (this params)]
              (bidi/encode-parameter v)
              (throw (ex-info (str "Cannot form URI without a value given for "
                                   this " parameter")
                              {}))))))

(defn external-routes
  [{:keys [gateway-base-url] :as _config}]
  {:gateway
   (branch gateway-base-url
           (leaf "/login"
                 :gateway/login))})

(defn server-routes []
  (branch "/"
          (leaf "" :index)
          (leaf "ping" :ping)
          (leaf "healthcheck" :healthcheck)
          (leaf "metrics" :metrics)
          (leaf "info" :info)
          (branch "submissions/"
                  (leaf "text" :webhook/text))
          (branch "api/"
                  (leaf "spellcheck" :api/spellcheck)
                  (leaf "queue" :api/queue-configs)
                  (branch "task"
                          (leaf "" :api/task-configs)
                          (leaf "/rejection-options" :api/rejection-options)
                          (branch "/" (param :task-config-id)
                                  (leaf "/summary" :api/task-summary)
                                  (leaf "/results" :api/task-results)
                                  (leaf "/documents" :api/task-documents)
                                  (branch "/document/" (param :document-id)
                                          (leaf "" :api/task-document))
                                  (leaf "/documentation-links" :api/task-documentation-links)
                                  (branch "/documentation-link/" (param :document-id)
                                          (leaf "" :api/task-documentation-link))))
                  (leaf "user" :api/user)
                  (branch "accounts/" (param :account-id)
                          (branch "/answers/" (param :answer-id)
                                  (leaf "" :api/answer-audio)))
                  (branch "edits"
                          (leaf "" :api/edits)
                          (leaf "/approve" :api/approve-edits))
                  (leaf "users" :api/users)
                  (branch "users/" (param :user-id)
                          (branch "/items"
                                  (leaf "" :api/items)
                                  (branch "/" (param :item-id)
                                          (leaf "/edits" :api/user-item-edits)
                                          (leaf "/feedback" :api/user-item-feedback)
                                          (leaf "/reports" :api/user-item-reports)
                                          (leaf "/defer" :api/defer-item)
                                          (leaf "/ignore" :api/ignore-item)))
                          (branch "/pending-item-groups"
                                  (leaf "" :api/pending-item-groups)))
                  (leaf "user-teams" :api/user-teams)
                  (branch "items"
                          (branch "/" (param :item-id)
                                  (leaf "" :api/item)))
                  (branch "item-groups/" (param :item-group-id)
                          (leaf "" :api/item-group)
                          (branch "/re-assign/" (param :user-id)
                                  (leaf "/" :api/re-assign)))
                  (branch "sessions/"
                          (branch "activity/" (param :user-id)
                                  (leaf "" :api/activity))
                          (leaf "events" :api/events))
                  (branch "viewed-items"
                          (leaf "" :api/user-viewed-items))
                  (branch "messages"
                          (leaf "" :api/messages)
                          (leaf "/active" :api/active-messages))
                  (branch "audit-items"
                          (leaf "" :api/audit-items))
                  (leaf "user-guide" :api/user-guide)
                  (branch "ingest"
                          (leaf "/submissions" :api/ingest-submissions)
                          (leaf "/task-configs" :api/ingest-task-configs)))
          (leaf "" :public)
          (leaf true :not-found)))

(defn client-routes
  []
  (branch "/"
          (leaf #{"" "index.html"} :manatee.routing.handlers/index)
          (leaf "sign-in" :manatee.auth.handlers/login)

          (leaf "annotate" :manatee.annotation.handlers/annotate)

          (leaf "dashboard" :manatee.dashboard.handlers/dashboard)

          (branch "admin" (leaf "" :manatee.admin.handlers/admin)
                  (leaf "/add-task" :manatee.task-config.add.handlers/add-task)
                  (branch "/task-config/" (param :task-config-id)
                          (leaf "" :manatee.task-config.edit.handlers/edit-task)
                          (leaf "/summary" :manatee.task-config.handlers/task-summary)
                          (leaf "/documents" :manatee.task-config.documents.handlers/task-documents)))

          (branch "sysadmin"
                  (leaf "" :manatee.sysadmin.handlers/main))

          (branch "qa"
                  (branch "/edits"
                          (leaf "" :manatee.edit.handlers/edits))
                  (branch "/users/" (param :user-id)
                          (branch "/item-group/" (param :item-group-id)
                                  (leaf "" :manatee.qa.handlers/item-group))
                          (branch "/items/" (param :item-id)
                                  (leaf "/edits" :manatee.qa.handlers/user-item-edits)
                                  (leaf "/reports" :manatee.qa.handlers/user-item-reports)))
                  (branch "/items"
                          (branch "/" (param :item-id)
                                  (leaf "" :manatee.qa.handlers/item)))

                  (branch "/compare-edits"
                          (branch "/user/" (param :user-a)
                                  (branch "/user/" (param :user-b)
                                          (branch "/item/" (param :item-id)
                                                  (leaf "" :manatee.qa.handlers/compare-item-edits)))))
                  (branch "/compare-item-group"
                          (branch "/user/" (param :user-a)
                                  (branch "/user/" (param :user-b)
                                          (branch "/item-group/" (param :item-group-id)
                                                  (leaf "" :manatee.qa.handlers/compare-item-group))))))

          (branch "not-found"
                  (leaf "" :manatee.not-found/not-found))
          (leaf true :manatee.not-found/not-found)))

(defn ui-routes
  [{:keys [base-url] :as _config}]
  (branch ""
          (branch base-url (server-routes))
          (client-routes)))
